import Vue from 'vue';
import VueI18n from 'vue-i18n';


Vue.use(VueI18n);
const zhLogin = require('./language').default.zhLogin
const enLogin = require('./language').default.enLogin
const frLogin = require('./language').default.frLogin

const message = {
    'zh-CN':zhLogin,
    'zh':zhLogin,
    'zh-cn':zhLogin,
    'en':enLogin,
    'en-US':enLogin,
    'fr-FR': frLogin,
    'fr':frLogin,
}
export default new VueI18n({
    locale: 'zh-CN',
    messages: message,
    silentTranslationWarn: true,
});